import { render, staticRenderFns } from "./SplitView.vue?vue&type=template&id=a45a217a&scoped=true&"
import script from "./SplitView.vue?vue&type=script&lang=js&"
export * from "./SplitView.vue?vue&type=script&lang=js&"
import style0 from "./SplitView.vue?vue&type=style&index=0&id=a45a217a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a45a217a",
  null
  
)

export default component.exports